// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__1ukFy","container_margin_top":"Home_container_margin_top__2vp0W","lms_text":"Home_lms_text__1wR6C"};